import React, { FunctionComponent } from 'react';
import styles from './quote.module.scss';

export interface IQuoteProps {
  content: string;
  author: string;
}

export const Quote: FunctionComponent<IQuoteProps> = ({ content, author }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.quoteIcons}>
        <i className={`material-icons md-40 md-primary`}>format_quote</i>
        <i className={`material-icons md-40 md-primary`}>format_quote</i>
      </div>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
      <div
        className={styles.author}
        dangerouslySetInnerHTML={{ __html: author }}
      ></div>
    </div>
  );
};
